import type { TiptapDoc } from '@odo/shared-ui';
import type { CaseChecklistPayload } from './checklist/caseChecklist';

interface TriggerNotesPayload {
    patientId: string;
    notes: string;
    notesDoc?: TiptapDoc;
}

export interface SubmitTriggerPayload extends TriggerNotesPayload {
    checklist?: CaseChecklistPayload;
}

export interface EditTriggerPayload extends TriggerNotesPayload {
    eventId: string;
}

async function submitTrigger(apiPath: string, payload: SubmitTriggerPayload): Promise<void> {
    const { default: apiV2 } = await import('../../../../../api/v2');
    await apiV2.post(`/patients/${payload.patientId}/vca/${apiPath}`, {
        notes: payload.notes,
        ...(payload.notesDoc ? { notesDoc: payload.notesDoc } : {}),
        ...(payload.checklist ? { checklist: payload.checklist } : {})
    });
}

async function editTrigger(apiPath: string, payload: EditTriggerPayload): Promise<void> {
    const { default: apiV2 } = await import('../../../../../api/v2');
    await apiV2.put(`/patients/${payload.patientId}/vca/${apiPath}/${payload.eventId}`, {
        notes: payload.notes,
        ...(payload.notesDoc ? { notesDoc: payload.notesDoc } : {})
    });
}

export { submitTrigger, editTrigger };
